/* eslint-disable jsx-quotes */
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';

import MetaSeo from '../MetaSeo';
import { Form, message } from 'antd';
import { getImageOffice } from '../../redux/actions/upload';
import useTrans from '../../hooks/useTrans';
import dynamic from 'next/dynamic';
const Lottie = dynamic(() => import('react-lottie'), { ssr: false });
import * as lottieData1 from '../../../assets/lottie/face_recognition.json';
import * as lottieData2 from '../../../assets/lottie/ai_video_motion_detection.json';
import * as lottieData3 from '../../../assets/lottie/linecross.json';
import * as lottieData4 from '../../../assets/lottie/anomaly_behavior_detection.json';
import * as lottieData5 from '../../../assets/lottie/hubmotion.json';
import * as lottieData6 from '../../../assets/lottie/vehicle_detection.json';
import * as lottieData7 from '../../../assets/lottie/defect_detection_in_manufacturing.json';

const dataLottie = {
  E9jLdVwpdjdbuDcK: lottieData1,
  '2aJDFEz7VNlwfaGq': lottieData2,
  FA4jJ4IeaJ3WK2wX: lottieData3,
  rgGc1CWXik903TVI: lottieData4,
  Fqwtm265gNKDT9oP: lottieData5,
  AO20Ka0u042XeDcW: lottieData6,
  fYD0AaScvM6Aqlvz: lottieData7,
};

export default function Technology(props) {
  const [isShowModal, setIsShowModal] = useState(false);
  const [rows, setRows] = useState(props.rows || []);
  const refYoutobe = useRef();
  const refClickYoutobe = useRef();
  const [list_image_office, setListImageOffice] = useState([]);
  const trans = useTrans();
  const handleClickOut = event => {
    const { target } = event;
    if (
      refYoutobe &&
      refClickYoutobe &&
      refClickYoutobe.current &&
      refYoutobe.current &&
      !refYoutobe.current.contains(target) &&
      !refClickYoutobe.current.contains(target)
    ) {
      setIsShowModal(false);
    }
  };

  useEffect(() => {
    setRows(props.rows);
    window.addEventListener('click', handleClickOut);
    return () => {
      window.removeEventListener('click', handleClickOut);
    };
  }, [props]);

  const dataSeo = {
    title: `${trans.layout.technology} | EYEFIRE`,
    description: trans.seo.technology.description,
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <section className="p-technology">
        <div className="c-big-banner">
          <div className="c-big-banner__image">
            <img
              className="w-100 item-pc"
              src="./assets/img/technology/bg-TechnologyNew.webp"
              alt=""
            />
            <img
              className="item-sp w-100"
              src="./assets/img/technology/img_big-banner-sp.webp"
              alt=""
            />
          </div>
          <div className="c-big-banner__inner">
            <div className="l-container">
              <div className="c-big-banner__content banner-technology">
                <h3 data-aos="fade-up">{trans.tecnology.hotTech}</h3>
                <p>{trans.tecnology.description}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="p-technology__main">
          <div className="l-container">
            {/* <div className="p-technology__main__box"> */}
            {rows.length &&
              rows.map((item, index) => {
                return (
                  <div
                    className={`p-technology__main__box ${
                      index % 2 !== 0 ? 'p-technology__main__box--02' : ''
                    } `}
                  >
                    <div className="p-technology__main__box-img">
                      <div className="p-technology__main__box-img--gif">
                        {item?.dataLottie ? (
                          <Lottie
                            options={{
                              loop: true,
                              autoplay: true,
                              animationData: item?.dataLottie,
                              rendererSettings: {
                                preserveAspectRatio: 'xMidYMid slice',
                              },
                            }}
                          />
                        ) : (
                          <img
                            className="w-100"
                            src={item.url_background}
                            alt=""
                          />
                        )}
                      </div>
                    </div>
                    <div className="p-technology__main__box-content">
                      <div className="p-technology__main__box-content--icon">
                        <img className="" src={item.image} alt="" />
                      </div>
                      <div className="p-technology__main__box-content--intro">
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                        <ul
                          style={
                            item?.description_sub?.length > 7
                              ? {
                                  display: 'grid',
                                  grid: 'auto auto auto/ auto auto',
                                }
                              : {}
                          }
                        >
                          {item.description_sub.length
                            ? item.description_sub.map(item_sub => {
                                return (
                                  <div
                                    style={{
                                      display: 'flex',
                                    }}
                                  >
                                    <li></li>
                                    <span>{item_sub.text} </span>
                                  </div>
                                );
                              })
                            : ''}
                        </ul>
                        {index === 4 && (
                          <div className="p-home__solution-btn btn-solution">
                            <a
                              href={'https://aiot.eyefire.vn/'}
                              target="_blank"
                              className="c-btn"
                              tabIndex="0"
                            >
                              {trans.text_button.more}
                            </a>
                            <img
                              src="/assets/img/home/icn_right.svg"
                              alt=""
                              loading="lazy"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );

                //         <div className="p-technology__box" data-aos="fade-up">
                //             <div className="p-technology__box__image item-pc">
                //                 <img
                //                     className="w-100"
                //                     src="./assets/img/technology/img_box-left.png"
                //                     alt=""
                //                 />
                //                 <div className="p-technology__box__image-gif">
                //                     {dataLottie[item.group_id] ? (
                //                         <Lottie
                //                             options={{
                //                                 loop: true,
                //                                 autoplay: true,
                //                                 animationData: dataLottie[item.group_id],
                //                                 rendererSettings: {
                //                                     preserveAspectRatio: 'xMidYMid slice',
                //                                 },
                //                             }}
                //                         />
                //                     ) : (
                //                         <img
                //                             className="w-100"
                //                             src={item.url_background}
                //                             alt=""
                //                         />
                //                     )}
                //                 </div>
                //             </div>
                //             <div className="p-technology__box__inner">
                //                 <div className="p-technology__box__content__img">
                //                     <img className="" src={item.image} alt="" />
                //                     {/* <img className="item-sp" src="./assets/img/technology/icn_box_01-sp.svg" alt="" /> */}
                //                 </div>
                //                 <div className="p-technology__box__content">
                //                     <div className="p-technology__box__title">
                //                         <h3>{item.title}</h3>
                //                     </div>
                //                     <div className="p-technology__box__desc">
                //                         <p>{item.description}</p>
                //                     </div>
                //                     <div className="p-technology__box__option">
                //                         <ul>
                //                             {item.description_sub.length
                //                                 ? item.description_sub.map(item_sub => {
                //                                     return <li>{item_sub.text} </li>;
                //                                 })
                //                                 : ''}
                //                         </ul>
                //                     </div>
                //                 </div>
                //             </div>
                //             <div className="p-technology__box__image item-sp">
                //                 <img
                //                     className="w-100"
                //                     src="./assets/img/technology/img_box-left-sp.png"
                //                     alt=""
                //                 />
                //                 <div className="p-technology__box__image-gif p-technology__box__image-gif--sp">
                //                     {dataLottie[item.group_id] ? (
                //                         <Lottie
                //                             options={{
                //                                 loop: true,
                //                                 autoplay: true,
                //                                 animationData: dataLottie[item.group_id],
                //                                 rendererSettings: {
                //                                     preserveAspectRatio: 'xMidYMid slice',
                //                                 },
                //                             }}
                //                         />
                //                     ) : (
                //                         <img
                //                             className="w-100"
                //                             src={item.url_background}
                //                             alt=""
                //                         />
                //                     )}
                //                 </div>
                //             </div>
                //         </div>
                //     );
                // }
                // return (
                //     <div
                //         className="p-technology__box p-technology__box--right"
                //         data-aos="fade-up"
                //     >
                //         <div className="p-technology__box__inner">
                //             <div className="p-technology__box__content__img">
                //                 <img className="" src={item.image} alt="" />
                //                 {/* <img className="item-pc" src="./assets/img/technology/icn_video.svg" alt="" />
                //                 <img className="item-sp" src="./assets/img/technology/icn_box_02-sp.svg" alt="" /> */}
                //             </div>
                //             <div className="p-technology__box__content">
                //                 <div className="p-technology__box__title">
                //                     <h3>{item.title}</h3>
                //                 </div>
                //                 <div className="p-technology__box__desc">
                //                     <p>{item.description}</p>
                //                 </div>
                //                 <div className="p-technology__box__option">
                //                     <ul>
                //                         {item.description_sub.length
                //                             ? item.description_sub.map(item_sub => {
                //                                 return <li>{item_sub.text} </li>;
                //                             })
                //                             : ''}
                //                     </ul>
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="p-technology__box__image item-pc">
                //             <img
                //                 className="w-100"
                //                 src="./assets/img/technology/img_box-right.png"
                //                 alt=""
                //             />
                //             <div className="p-technology__box__image-gif">
                //                 {dataLottie[item.group_id] ? (
                //                     <Lottie
                //                         options={{
                //                             loop: true,
                //                             autoplay: true,
                //                             animationData: dataLottie[item.group_id],
                //                             rendererSettings: {
                //                                 preserveAspectRatio: 'xMidYMid slice',
                //                             },
                //                         }}
                //                     />
                //                 ) : (
                //                     <img
                //                         className="w-100"
                //                         src={item.url_background}
                //                         alt=""
                //                     />
                //                 )}
                //             </div>
                //         </div>
                //         <div className="p-technology__box__image item-sp">
                //             <img
                //                 className="w-100"
                //                 src="./assets/img/technology/img_box-right-sp.png"
                //                 alt=""
                //             />
                //             <div className="p-technology__box__image-gif p-technology__box__image-gif--sp">
                //                 {dataLottie[item.group_id] ? (
                //                     <Lottie
                //                         options={{
                //                             loop: true,
                //                             autoplay: true,
                //                             animationData: dataLottie[item.group_id],
                //                             rendererSettings: {
                //                                 preserveAspectRatio: 'xMidYMid slice',
                //                             },
                //                         }}
                //                     />
                //                 ) : (
                //                     <img
                //                         className="w-100"
                //                         src={item.url_background}
                //                         alt=""
                //                     />
                //                 )}
                //             </div>
                //         </div>
                //     </div>
                // );
              })}
            {/* </div> */}
          </div>

          {/* <div className='l-container'>
                        <div className='p-technology__main__box'>
                            <div className='p-technology__main__box-img'>
                                <div className='p-technology__main__box-img--bg'>
                                    <img className='w-100' src='./assets/img/technology/bg_box-1.png' alt='' />
                                </div>
                                <div className='p-technology__main__box-img--gif'>
                                    <img className='w-100' src='./assets/img/technology/img_box-1.png' alt='' />
                                </div>
                            </div>
                            <div className='p-technology__main__box-content'>
                                <div className='p-technology__main__box-content--icon'>
                                    <img src='./assets/img/technology/icn_box-1.svg' />
                                </div>
                                <div className='p-technology__main__box-content--intro'>
                                    <h3>Face Recognition</h3>
                                    <p>Công nghệ nhận diện khuôn mặt độ chính xác cao, tốc độ nhanh, đa nền tảng thiết bị [Face Detection, Face Recognition, People Queue Detection]</p>
                                    <ul>
                                        <li>Đa thiết bị, đa nền tảng: Có thể nhận diện trên server, hoặc tại các thiết bị di động (mobile, tablet, devices) chạy hệ điều hành iOS, Android</li>
                                        <li>Độ chính xác trên 99%</li>
                                        <li>Tốc độ nhận diện dưới 1s</li>
                                        <li>Chỉ cần lấy 1 ảnh mẫu duy nhất</li>
                                        <li>Chống giả mạo tuyệt đối</li>
                                        <li>Dễ dàng tích hợp với các ứng dụng, các hệ thống có sẵn</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className='p-technology__main__box p-technology__main__box--03'>
                            <div className='p-technology__main__box-img'>
                                <div className='p-technology__main__box-img--bg'>
                                    <img className='w-100' src='./assets/img/technology/bg_box-3.png' alt='' />
                                </div>
                                <div className='p-technology__main__box-img--gif'>
                                    <img className='w-100' src='./assets/img/technology/img_box-3.png' alt='' />
                                </div>
                            </div>
                            <div className='p-technology__main__box-content'>
                                <div className='p-technology__main__box-content--icon'>
                                    <img src='./assets/img/technology/icn_line-cros.svg' />
                                </div>
                                <div className='p-technology__main__box-content--intro'>
                                    <h3>Line Crossing<br className='item-pc' />Detection</h3>
                                    <p>Công nghệ line crossing với độ chính xác cao,<br className='item-pc' /> thời gian thực, ứng dụng để đếm người, hàng rào <br className='item-pc' /> ảo, phát hiện xâm nhập vùng cấm</p>
                                    <div className='p-technology__main__box-content--intro-option'>
                                        <ul>
                                            <li>People Counting</li>
                                            <li>Object Line Crossing Detection</li>
                                            <li>Object Enter Area Detection</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='p-technology__main__box p-technology__main__box--04'>
                            <div className='p-technology__main__box-img'>
                                <div className='p-technology__main__box-img--bg'>
                                    <img className='w-100' src='./assets/img/technology/bg_box-4.png' alt='' />
                                </div>
                                <div className='p-technology__main__box-img--gif'>
                                    <img className='w-100' src='./assets/img/technology/img_box-4.png' alt='' />
                                </div>
                            </div>
                            <div className='p-technology__main__box-content'>
                                <div className='p-technology__main__box-content--icon'>
                                    <img src='./assets/img/technology/icn_anomaly.svg' />
                                </div>
                                <div className='p-technology__main__box-content--intro'>
                                    <h3>Anomaly Behavior <br className='item-pc' />Detection</h3>
                                    <p>Công nghệ phát hiện hành vi bất thường <br className='item-pc' /> thông qua phân tích video, luồng camera. </p>
                                    <ul>
                                        <li>Fighting Detection</li>
                                        <li>Abnormal Shopping Detection</li>
                                        <li>Slip & Fall Detection</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='p-technology__main__box p-technology__main__box--05'>
                            <div className='p-technology__main__box-img'>
                                <div className='p-technology__main__box-img--bg'>
                                    <img className='w-100' src='./assets/img/technology/bg_box-5.png' alt='' />
                                </div>
                                <div className='p-technology__main__box-img--gif'>
                                    <img className='w-100' src='./assets/img/technology/img_box-5.png' alt='' />
                                </div>
                            </div>
                            <div className='p-technology__main__box-content'>
                                <div className='p-technology__main__box-content--icon'>
                                    <img src='./assets/img/technology/icn_camera.svg' />
                                </div>
                                <div className='p-technology__main__box-content--intro'>
                                    <h3>AIoT Camera Solutions</h3>
                                    <p>Biến camera thường thành AI camera, xem và lưu trữ tập trung.</p>
                                    <div className='p-technology__main__box-content--intro-option'>
                                        <ul>
                                            <li>Live View</li>
                                            <li>Recording</li>
                                            <li>Face Recognition</li>
                                            <li>Line Crossing Detection</li>
                                            <li>Intrusion Detection</li>
                                        </ul>
                                        <ul>
                                            <li>Anomaly Behavior Detection</li>
                                            <li>Missing Object Detection</li>
                                            <li>Smoke Detection</li>
                                            <li>Heat Map</li>
                                            <li>Traffic Monitoring</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
        </div>
      </section>
    </>
  );
}
